import {
  applyHealthPollCycle,
  createConfirmedOfflineState,
  type ConfirmedOfflineState,
} from "@/hooks/confirmedOffline";
import { useServerStatusStore } from "@/hooks/serverStatusStore";

let state: ConfirmedOfflineState = createConfirmedOfflineState();

function syncStoreStatus(): void {
  useServerStatusStore.getState().setStatus(state.status);
}

/** Read-only snapshot for tests and diagnostics. */
export function getConnectivityState(): ConfirmedOfflineState {
  return state;
}

/** One failed health poll cycle or transport failure (NETWORK_ERROR / TIMEOUT). */
export function recordConnectivityFailure(): ConfirmedOfflineState {
  state = applyHealthPollCycle(state, "failure");
  syncStoreStatus();
  return state;
}

/** Successful health poll — resets the failure streak and may recover from offline. */
export function recordConnectivitySuccess(): ConfirmedOfflineState {
  state = applyHealthPollCycle(state, "success");
  syncStoreStatus();
  return state;
}

/** Logout / authenticated layout unmount — clear streak and force online. */
export function resetConnectivityState(): void {
  state = createConfirmedOfflineState();
  syncStoreStatus();
}
